import { render } from "./InputSuccess.vue?vue&type=template&id=40fbb870"
import script from "./InputSuccess.vue?vue&type=script&lang=js"
export * from "./InputSuccess.vue?vue&type=script&lang=js"

import exportComponent from "/builds/rclass/new_shlepakov/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__